import { Flex } from '@ui-library/misc';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BI_TRACKER, TRACK_EVENT_TYPES, BI_EVENTS } from '@lib/utils/analytics';
import { CustomText, BorderText } from '@auth/common/styles';
import { URLS } from '@components/common/constants';
import { Path } from '@components/routes';

interface Props {
  type: string;
}

const Footer = ({ type }: Props) => {
  const location = useLocation();

  const handleLogin = () => {
    if (location.pathname.includes('blendo')) {
      return '/blendoLogin';
    }
    return Path.LOGIN;
  };

  const BorderTextStyle: React.CSSProperties = {
    width: '350px',
    marginTop: '16px',
  };

  return (
    <Flex flexDirection="column">
      <CustomText className="m-t-md" fontSize="14px" lineHeight="22px">
        Already have an account?{' '}
        <Link
          className="link-blue"
          onClick={() => BI_TRACKER(BI_EVENTS.LOGIN, TRACK_EVENT_TYPES.ACTION, { type })}
          to={handleLogin()}
        >
          Login
        </Link>
      </CustomText>
      <BorderText style={BorderTextStyle}>
        By signing up, I agree to the RudderStack&#39;s &nbsp;
        <a
          href={URLS.PRIVACY_POLICY}
          target="_blank"
          className="link-blue"
          onClick={() => BI_TRACKER(BI_EVENTS.PRIVACY_POLICY, TRACK_EVENT_TYPES.ACTION)}
          rel="noreferrer"
        >
          Privacy Policy{' '}
        </a>{' '}
        and
        <a
          href={URLS.TERMS_OF_SERVICE}
          target="_blank"
          className="link-blue"
          onClick={() => BI_TRACKER(BI_EVENTS.TERMS_OF_SERVICE, TRACK_EVENT_TYPES.ACTION)}
          rel="noreferrer"
        >
          {' '}
          Terms of Service
        </a>{' '}
        &nbsp;
      </BorderText>
    </Flex>
  );
};

export default Footer;
